import React, { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { queryDemGroups } from "../logics/demandGroups";
import { Plus } from "react-bootstrap-icons";
import { DemandRate } from "../atoms/DemandRate";
import { DemandStatus } from "../atoms/DemandStatus";
import { DemandFiles } from "../molecules/DemandFiles";
import { IDem } from "../logics/types";
import { empty, kopecks2rubStr, validatePhoneRU } from "../../../common/functions";
import {
  IQuerySetDemRateResult,
  querySetDemRate,
} from "../logics/demandRating";
import { toast } from "react-toastify";
import { LTextarea } from "../../../common/ui/ltextarea";
import "../styles/ShowPayDemand.css";
import { $SiteColors } from "../../../common/config/company-atts";
import { $contractorDems } from "../logics/contractorDemands";
import { clearNotification } from "../../../common/ui/Header/logics/notificationsLogic";

interface IShowFreeDemand {
  dem: IDem; //заявка
  setShowIdx: React.Dispatch<React.SetStateAction<number>>; //при нажатии на кнопку закрытия переводим состояние в "-1"
  companyId: number; //компания, по которому запрашиваем группы
  setSuccess: React.Dispatch<React.SetStateAction<boolean>>; //переводим в true при успешном редактировании заявки
  showRate: boolean
}

export const ShowPayDemand = ({
  dem,
  companyId,
  setShowIdx,
  setSuccess,
  showRate,
}: IShowFreeDemand) => {
  const [rateComment, setRateComment] = useState(""); //коммент к оценке
  const [hideRateComment, setHideRateComment] = useState(true);
  const [rate, setRate] = useState<number | null>(dem?.rating); //оценка к заявке
  const [saveRateResult, setSaveRateResult] = useState<IQuerySetDemRateResult>({
    loaded: false,
    fail: false,
    msg: "",
  });

  useEffect(() => {
    queryDemGroups({ accountId: dem.accountId, companyId: companyId });
  }, []);

  // Закрытие карточки по Escape + блокировка скролла фона, пока карточка открыта.
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") { setShowIdx(-1); clearNotification(); }
    };
    document.addEventListener("keydown", onKeyDown);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = prevOverflow;
    };
  }, []);

  useEffect(() => {
    // комментарий и «Сохранить оценку» — только у выполненных (статус 5) неоценённых заявок, когда выбрана оценка
    if (showRate && Number(dem?.lastStatusId) === 5 && Number(rate) > 0 && (empty(dem?.rating) || Number(dem?.rating) === 0)) setHideRateComment(false);
  }, [rate]);

  useEffect(() => {
    if (saveRateResult.loaded) {
      if (saveRateResult.fail) toast.error(saveRateResult.msg);
      else {
        toast.success("Данные обновлены");
        setSuccess(true);   // обновляет список заявок (DemandList)
        setShowIdx(-1);     // закрывает форму просмотра
      }
    }
  }, [saveRateResult]);

  const onSaveRateClicked = () => {
    //@ts-ignore
    querySetDemRate(dem.id, rate, rateComment, setSaveRateResult);
  };

  // неоценённая заявка приходит с rating=0 (а empty(0)===false), поэтому 0 тоже считаем «не оценено»
  let isRateEmpty = empty(dem?.rating) || Number(dem?.rating) === 0;
  //@ts-ignore
  let phone = empty(dem?.phone) ? "" : dem?.phone;
  //@ts-ignore 
  let validated = validatePhoneRU(phone);
  let isAnswerEmpty = empty(dem?.answer);
  
  let fullDem = $contractorDems.getState().services.find(e=>e.id === dem?.contractorDemandId)

  return (
    <>
      <div className="omodal">
        <div className="omodal-content" style={{ background: "#F0F2F5", borderRadius: "12px" }} id="omodalContent" >
          <div className="row col-12 d-flex m-auto pl-0 pr-0" style={{ paddingBottom: "10px" }}>
            <div className="spd_title">Заявка № {dem?.id}</div>
            <div className="ml-auto">
            <Button onClick={() => {setShowIdx(-1); clearNotification()}} variant="default" className="spd_btn_close" >
                <Plus style={{ transform: "rotate(45deg)", width: "100%", height: "100%" }} />
              </Button>
            </div>
          </div>
          <DemandStatus statusName={dem?.statusName} add2Class="div-status-in-show-dem"statusId={dem?.lastStatusId}/>
          <div className="spd_desire_date_and_interval_con">
            <div className="mr-2"><Form.Control value={dem?.desireDate == null ? "" : dem?.desireDate} readOnly={true} className="spd_box_shadow_and_radius" type="date"/></div>
            <div><Form.Control value={dem?.desireTimeInterval == null ? "" : dem?.desireTimeInterval} readOnly={true} className="spd_box_shadow_and_radius" type="text" list="desireTimeInterval"/></div>
          </div>
          <div style={{ marginBottom: "24px" }}>
          <Form.Control value={dem?.fio} readOnly={true} className="spd_box_shadow_and_radius" title="ФИО" placeholder="Введите ФИО" type="text"/>
            {/*<LInput  readonly={true} val={dem.fio} legendText={"ФИО"} placeholder={"ФИО"} />*/}
          </div> 
          <div style={{ marginBottom: "24px" }}>
            <Form.Control 
            //@ts-ignore
            value={validated.ok ? validated.phone : phone} readOnly={true} className="spd_box_shadow_and_radius" title="Номер телефона" placeholder="Введите номер телефона" type="text"/>
            {/*<LInput  readonly={true} val={validated.ok ? validated.phone : phone} legendText={"Телефон"} placeholder={"Телефон"} />*/}
          </div>
          <div className="spd_label_order">
            <span>Заказ</span>
          </div>
          <div  className="row col-12 spd_service_info_con" >
            <div className="row col-12 m-auto pt-2 pl-2 pr-2 "> {/*d-flex mr-auto ml-auto pl-0 pr-0 bg-white */}
              <span className="col mr-auto" style={{fontWeight: 700, color: "#3D4652"}}>{fullDem?.name}</span>
            </div>
            <div className="row col-12 m-auto p-2">
              <span className="col mr-auto mt-auto mb-auto" style={{fontWeight: 900}}>{
                //@ts-ignore
              kopecks2rubStr(fullDem?.price ? fullDem.price * dem?.qty: 0)}</span><div className="ml-auto" style={{paddingRight: "0.5rem"}}>{`${dem.qty}${fullDem?.unit_name ? " " + fullDem.unit_name : ""}`}</div>
            </div>
            {empty(fullDem?.contractors_name) ? <></>: 
            <div className="row col-12 spd_provider_con">
              <span className="col mr-auto" >Поставщик: {fullDem?.contractors_name}</span>
            </div>}
          </div>
          <Button hidden={!isAnswerEmpty}  variant="link" className="spd_btn_comment_from_uk">Комментарий от УК отсутствует</Button>
          <div hidden={isAnswerEmpty} style={{ marginBottom: isAnswerEmpty ? "0px" : "24px" }}>
            <LTextarea
              //@ts-ignore
              val={empty(dem?.answer) ? "" : dem?.answer}
              legendText={"Комментарий от УК"}
              rows={2}
              readonly={true}
              placeholder="Комментарий от УК"
            />
          </div>
          {!showRate ? <></>:
            <DemandRate rate={rate} max={5} //@ts-ignore
            setRate={setRate} readonly={ Number(dem?.lastStatusId) !== 5 || !isRateEmpty }
            add2class={(Number(dem?.lastStatusId) !== 5 || !isRateEmpty) ? "div-dem-rate-not-clickable" : "div-dem-rate"}/>
          }
          {hideRateComment ? <></> :
            <>
              <textarea value={rateComment} onChange={(e) => setRateComment(e.target.value)} className="form-control spd_dem_comment" hidden={hideRateComment} placeholder="Оставьте комментарий к оценке" rows={1}></textarea>
              <div className="text-center" hidden={hideRateComment} style={{ marginBottom: "24px" }}>
                <Button onClick={() => onSaveRateClicked()} variant="default" className="spd_btn_save_rate" style={{ background: $SiteColors.getState().backBtnSubmit }}>
                  Сохранить оценку
                </Button>
              </div>
            </>
          }
          <DemandFiles demid={dem.id} />
        </div>
      </div>
    </>
  );
};
